export default __webpack_public_path__ + "static/media/horselove.2fdff134.svg";